// extracted by extract-css-chunks-webpack-plugin
module.exports = {"separator":"Separator__separator"};